require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-burgauberg-neudauberg.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-burgauberg-neudauberg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-burgauberg-neudauberg!./.cache/json/betreuungseinrichtungen-guessing-burgauberg-neudauberg.json
// module id = 883
// module chunks = 231608221292675